import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  fetchPendingLabTests,
  selectLabTests,
  selectLabTestsLoading,
} from '../../../ReduxSlices/LabTests/labTestSlice';

import LoadingDots from '../../shared/LoadingDots';

const PendingLabTest = () => {
  const dispatch = useDispatch();

 const labTests = useSelector(selectLabTests).filter(
  (test) => test.status === 'pending'
  );
  const loading = useSelector(selectLabTestsLoading);

  const [submitting, setSubmitting] = useState({});
  const [resultInput, setResultInput] = useState({});

  useEffect(() => {
    dispatch(fetchPendingLabTests());
  }, [dispatch]);

  const handleResultSubmit = async (testId) => {
    const result = resultInput[testId];

    if (!result || result.trim() === '') {
      alert('Please enter a result.');
      return;
    }

    if (submitting[testId]) return;

    setSubmitting((prev) => ({
      ...prev,
      [testId]: true,
    }));

    try {
      const res = await fetch(`/api/v1/lab_tests/${testId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          lab_test: {
            result,
            status: 'completed',
          },
        }),
      });

      if (!res.ok) {
        throw new Error('Failed to submit result');
      }

      // no manual redux update needed
      // websocket broadcast updates redux automatically

    } catch (error) {
      console.error(error);
      alert('Submission failed');
    } finally {
      setSubmitting((prev) => ({
        ...prev,
        [testId]: false,
      }));
    }
  };

  return (
    <>
      <h2 className="text-xl font-bold">
        Pending Lab Tests
      </h2>

      <div className="pending-tests">

        {loading && (
          <LoadingDots
            height={10}
            width={30}
            color="#38AD3E"
          />
        )}

        {!loading && labTests.length === 0 && (
          <p>No pending lab tests.</p>
        )}

        {!loading &&
          labTests.map((test) => (
            <div
              key={test.id}
              className="pending-test border p-4 rounded shadow"
            >
              <p>
                <strong>Patient:</strong>{' '}
                {test.patient?.name}
              </p>

              <p>
                <strong>Test Type:</strong>{' '}
                {test.lab_test_type?.name}
              </p>

              <p>
                <strong>Doctor Notes:</strong>{' '}
                {test.doctor_notes || 'N/A'}
              </p>

              <textarea
                rows={2}
                placeholder="Enter result..."
                className="w-full border rounded p-2 my-2"
                value={resultInput[test.id] || ''}
                onChange={(e) =>
                  setResultInput({
                    ...resultInput,
                    [test.id]: e.target.value,
                  })
                }
              />

              <button
                type="button"
                onClick={() => handleResultSubmit(test.id)}
                className="primary"
                disabled={submitting[test.id]}
              >
                {submitting[test.id]
                  ? 'Submitting...'
                  : 'Submit Result'}
              </button>
            </div>
          ))}
      </div>
    </>
  );
};

export default PendingLabTest;